import Page from 'components/Page';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import { FaPencilAlt, FaTrashAlt} from 'react-icons/fa';



const FormPage = () => {
  return (
    <Page title="Formulario 2" breadcrumbs={[ { name: 'Formulario 2', active: true } ]}>

        <Card>
            <CardBody>
            <Form>
                <Row >
                    
                    <Col  xl={2} lg={2} md={2}>
                        <FormGroup>
                            <Label for="rut">RUT</Label>
                            <Input
                                type="text"
                                name="rut"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                    <Col  xl={4} lg={4} md={4}>
                        <FormGroup>
                            <Label for="rut">Razón social</Label>
                            <Input
                                type="text"
                                name="rut"
                                placeholder=""
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Card className="card-interior">
                        <CardHeader>Sucursales</CardHeader>
                        <CardBody>
                            <Row>
                                <Col  xl={3} lg={3} md={3}>
                                    <FormGroup>
                                        <Label for="direccion">Dirección</Label>
                                        <Input
                                            type="text"
                                            name="direccion"
                                            placeholder=""
                                        />
                                    </FormGroup>
                                </Col>
                                <Col  xl={2} lg={2} md={2}>
                                    <FormGroup>
                                        <Label for="calle">Calle</Label>
                                        <Input
                                            type="text"
                                            name="calle"
                                            placeholder=""
                                        />
                                    </FormGroup>
                                </Col>
                                <Col  xl={2} lg={2} md={2}>
                                    <FormGroup>
                                        <Label for="numero">Número</Label>
                                        <Input
                                            type="text"
                                            name="numero"
                                            placeholder=""
                                        />
                                    </FormGroup>
                                </Col>
                                <Col  xl={2} lg={2} md={2}>
                                    <FormGroup>
                                        <Label for="comuna">Comuna</Label>
                                        <Input
                                            type="text"
                                            name="comuna"
                                            placeholder=""
                                        />
                                    </FormGroup>
                                </Col>

                                <Col  xl={2} lg={2} md={2}>
                                    <Button className="btn-cuerpo"  color="primary" size="sm">Agregar sucursal</Button>
                                </Col>

                                <Col >
                                    <Table size="sm" striped bordered className="tabla-general">
                                        <thead>
                                            <tr>
                                                <th>Dirección</th>
                                                <th>Calle</th>
                                                <th>Número</th>
                                                <th>Comuna</th>
                                                <th className="text-center">Opciones</th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Barros Arana, 194, Concepción</td>
                                                <td>Barros Arana</td>
                                                <td>194</td>
                                                <td>Concepción</td>
                                                <td className="text-center td-botones">
                                                    <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                                                    <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Barros Arana, 194, Concepción</td>
                                                <td>Barros Arana</td>
                                                <td>194</td>
                                                <td>Concepción</td>
                                                <td className="text-center td-botones">
                                                    <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                                                    <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                                                </td>
                                            </tr>
        
                                            
                                        </tbody>
                                    </Table>                     
                                
                                </Col>

                            </Row>
                         
                        </CardBody>
                    </Card>
                </Row>

                <br/>
                <Row>
                    <Col  xl={12} lg={12} md={12}>
                    <Button color="primary" size="sm">Guardar</Button>
                    </Col>
                </Row>
     
            </Form>
            </CardBody>


        </Card>

        

        <br/>


        <Table size="sm" striped bordered className="tabla-general">
            <thead>
                <tr>
                    <th>RUT</th>
                    <th>Razón social</th>
                    <th>Sucursales</th>
                    <th className="text-center">Opciones</th>
                </tr>

            </thead>
            <tbody>
                <tr>
                    <td>76123456-9</td>
                    <td>Empresa ejemplo ltda.</td>
                    <td>2</td>
                    <td className="text-center td-botones">
                        <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                        <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                    </td>
                </tr>
                <tr>
                    <td>76123456-9</td>
                    <td>Empresa ejemplo ltda.</td>
                    <td>2</td>
                    <td className="text-center td-botones">
                        <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                        <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                    </td>
                </tr>
                <tr>
                    <td>76123456-9</td>
                    <td>Empresa ejemplo ltda.</td>
                    <td>2</td>
                    <td className="text-center td-botones">
                        <Button color="secondary" className="btn-tabla"> <FaPencilAlt/></Button>
                        <Button color="danger" className="btn-tabla"><FaTrashAlt/></Button>
                    </td>
                </tr>
              
                
            </tbody>
        </Table>     


    </Page>
  );
};

export default FormPage;
